import React, { useEffect } from "react";

import { useStoreActions, useStoreState } from 'easy-peasy';
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

import PropTypes from 'prop-types';
import useBackButton from "../../hooks/useBackButton";
import ActivityFormComponent from "../../components/activity/ActivityFormComponent";
import Loader from "../../components/widgets/Loader";

const CreateActivity = ({ type = null }) => {

    const { activityById } = useStoreState(state => state.activity);
    const { fetchActivityById, isFetchingOneActivity } = useStoreActions(actions => actions.activity);

    const { uniqueId } = useParams();

    useEffect(() => {
        if (type === 'edit' && uniqueId) {
            fetchActivityById(uniqueId);
        }
    }, [uniqueId]);

    const { backButtonComponent } = useBackButton()

    return (
        <div className="container p-2">
            <Row className="mb-3">
                <Col className="d-flex justify-content-between align-items-center">
                    <h2>{type === "edit" ? "Modifier une activité" : "Ajout d'une activité"}</h2>
                    {backButtonComponent}
                </Col>
            </Row>
            {type === 'edit' && (isFetchingOneActivity || !activityById) ?
                <Loader />
                : <ActivityFormComponent existingActivity={type === 'edit' ? activityById : null} />
            }

        </div>
    );
};

CreateActivity.propTypes = {
    type: PropTypes.string,
};

export default CreateActivity;
